import script from "./MainContentBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainContentBase.vue?vue&type=script&setup=true&lang=ts"

import "./MainContentBase.vue?vue&type=style&index=0&id=1579d6ea&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1579d6ea"]])

export default __exports__